import { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import WebApp from '@twa-dev/sdk';
import { setupTelegramWindowObject } from '@Utils/telegram';
import { Buffer } from 'buffer';
import 'flag-icons/css/flag-icons.min.css';
import { GenericApolloProvider } from '@/apollo';
import { ContextInterLayer } from '@Global/store';
import { App } from './App';
import initI18n from './i18n/config';
import './index.css';
import { persistor, store } from './store/redux';
import './tailwind-input.css';
import { ErrorBoundary } from './ui/ErrorBoundary';
import { addMatchMediaSupport } from './utils/addMatchMediaSupport';
import { initSentry } from './utils/sentry';
import { persistSuperInitData } from './utils/telegram/persistSuperInitData';
import './variables.css';

window.Buffer = window.Buffer || Buffer;
WebApp.expand();

if ('scrollRestoration' in history) {
  history.scrollRestoration = 'auto';
}

initSentry();

persistSuperInitData();
setupTelegramWindowObject();
initI18n();
addMatchMediaSupport();

/** инициалзиатор */
const Fanton = () => {
  return (
    <ErrorBoundary>
      <GenericApolloProvider>
        <ContextInterLayer>
          <Suspense fallback={null}>
            <Provider store={store}>
              <PersistGate loading={null} persistor={persistor}>
                <App />
              </PersistGate>
            </Provider>
          </Suspense>
        </ContextInterLayer>
      </GenericApolloProvider>
    </ErrorBoundary>
  );
};

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(<Fanton />);
